import { DATADOG_RUM_FOR_DEV } from './constants';

const TTL_MS = 12 * 60 * 60 * 1000;

interface OverrideRecord {
    exp: number;
}

function readOverride(): OverrideRecord | null {
    try {
        const raw = localStorage.getItem(DATADOG_RUM_FOR_DEV);
        return raw ? (JSON.parse(raw) as OverrideRecord) : null;
    } catch {
        return null;
    }
}

function writeOverride(record: OverrideRecord | null): void {
    try {
        if (record === null) {
            localStorage.removeItem(DATADOG_RUM_FOR_DEV);
        } else {
            localStorage.setItem(DATADOG_RUM_FOR_DEV, JSON.stringify(record));
        }
    } catch {
        // storage unavailable
    }
}

export function isForceEnabled(): boolean {
    const record = readOverride();
    return record !== null && typeof record.exp === 'number' && Date.now() < record.exp;
}

export function enableOverride(): void {
    writeOverride({ exp: Date.now() + TTL_MS });
}

export function clearOverride(): void {
    writeOverride(null);
}
